import { render } from "./WikiSearchComponent.vue?vue&type=template&id=48796cf0&scoped=true&ts=true"
import script from "./WikiSearchComponent.vue?vue&type=script&lang=ts"
export * from "./WikiSearchComponent.vue?vue&type=script&lang=ts"

import "./WikiSearchComponent.vue?vue&type=style&index=0&id=48796cf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48796cf0"]])

export default __exports__